<template>
  <v-flex :id="'espera-' + paciente.id">
      <v-hover v-slot="{ hover }">
      <v-card :elevation="hover ? 5 : 2" class="item" @click="visualizarItem">
        <v-container>
          <div class="container-pessoa-sala">
            <div class="text-head d-inline-block d-inline-block text-truncate max-width-item">
              <span class="text-info">{{ paciente.nome }}</span>
            </div>
            <span class="text-info">{{ paciente.sexo }}</span><br/>
            <div class="container-contador-tempo">
              <v-icon color="primary">mdi-clock-outline</v-icon>
              <contador-tempo :dataReferencia="paciente.dataEntrada" class-name="relogio-sala-espera" />
            </div>
          </div>
        </v-container>
        <v-overlay :value="hover" absolute>
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon>
                  <v-icon size="30" >mdi-eye</v-icon>
                </v-btn>
              </template>
              Visualizar
            </v-tooltip>
          </div>
        </v-overlay>
      </v-card>
      </v-hover>
  </v-flex>
</template>

<script>
import ContadorTempo from '@/views/components/ContadorTempo.vue'

export default {
    name: 'PacienteEsperaCard',
    components: {ContadorTempo},
    props: {
        paciente: {
            default: () => {
                return {}
            },
        },
    },
    methods: {
        visualizarItem(){
            this.$emit('visualizarItem', this.paciente)
        },
    }
}
</script>


<style scoped lang="stylus">

.item
  border 1px solid #777
.item:hover
  cursor pointer

.container-pessoa-sala
  display flex
  flex-direction column

.text-info
  color #777

.text-head
  font-weight bold
  font-size 20px

.max-width-item
  max-width 99%

.relogio-sala-espera
  font-weight bold
  color #777
  font-size 14px

.container-contador-tempo
  display flex
  align-items center
  justify-content right

</style>